import { useQuery } from '@tanstack/react-query'
import { listAchievements } from '../api/achievements'
import { ACHIEVEMENT_TYPE } from '../constants/api'
import type { AchievementCarouselSection } from '../constants/home'
import { QUERY_KEYS } from '../constants/query'
import { toApiMessage } from '../helpers/api-error'
import { mapPartnerLogos } from '../helpers/mapContent'
import {
  findAchievementCarousel,
  groupPartnerLogosByType,
} from '../helpers/partners'

type PartnerLogosState = {
  recognized: AchievementCarouselSection | null
  partner: AchievementCarouselSection | null
  loading: boolean
  error: string | null
}

export function usePartnerLogos(): PartnerLogosState {
  const achievementsQuery = useQuery({
    queryKey: QUERY_KEYS.achievements,
    queryFn: () => listAchievements(true),
  })
  const error = achievementsQuery.error
    ? toApiMessage(achievementsQuery.error, 'Failed to load partner logos')
    : null
  const sections = groupPartnerLogosByType(
    mapPartnerLogos(achievementsQuery.data ?? []),
  )

  return {
    recognized: findAchievementCarousel(sections, ACHIEVEMENT_TYPE.recognized),
    partner: findAchievementCarousel(sections, ACHIEVEMENT_TYPE.partner),
    loading: achievementsQuery.isPending && !achievementsQuery.data && !error,
    error,
  }
}
